import { ComponentBaseProps } from "../../../components/ComponentBase";
import RupIcons from "../../../RupIcons";
import GlobalSearchState, { ContentSearchBlock, SearchBlockType } from "../typings";
import SearchBlock from "./SearchBlock";
import SearchBox from "./SearchBox";

export interface SearchBoxPresentationProps extends ComponentBaseProps {
	readonly state: GlobalSearchState;
	readonly action: (event: JQueryEventObject, isShown?: boolean) => void;
}

export default class SearchBoxPresentation extends SearchBox {

	public searchPresentation: JQuery;
	private more: JQuery;

	constructor(props: SearchBoxPresentationProps) {
		super(props);
	}

	public hideOverflow(): void {
		this.resetOverflowHidden();
		let isOverflow = false;

		const blocks = [...this.blocks];
		blocks.reverse();

		blocks.every(block => {
			if (this.getWidth(this.container) < this.getWidth(this.searchPresentation)) {
				block.container.addClass("globalSearch__chip--hidden");
				isOverflow = true;
				return true;
			} else {
				if (isOverflow) {
					block.container.addClass("globalSearch__chip--hidden");
				}
				return false;
			}
		});

		if (isOverflow) {
			this.more = $("<div>")
				.addClass("globalSearch__moreButtonContainer")
				.append($("<div>")
				.addClass("rup-global-search__more-button globalSearch__moreButton")
				.append(RupIcons.more));

			this.searchPresentation.append(this.more);
		}
	}

	private resetOverflowHidden() {
		this.more?.remove();
		this.blocks.forEach(block => block.container.removeClass("globalSearch__chip--hidden"));
	}

	private getWidth(element: JQuery) {
		return element[0].getBoundingClientRect().width;
	}

	protected renderInternal(): JQuery {
		this.searchPresentation = $("<button>")
			.addClass("rup-global-search__box--active globalSearch__button globalSearch__presentation")
			.attr("type", "button")
			.click(this.props.action);

		this.containerInternal = $("<div>")
			.addClass("rup-global-search__box")
			.append(this.searchPresentation);

		const blocks = this.props.state.contentSearchBlockList;
		if (blocks?.length) {
			blocks.forEach(block => this.addChip(block));
		}

		return this.containerInternal;
	}

	public addChip(term: ContentSearchBlock): void {
		let block: SearchBlock;
		if (term.type !== SearchBlockType.Operator) {
			block = this.addVocabBlock(term);
		} else {
			block = this.addOperatorBlock(term);
		}

		this.searchPresentation.append(block?.render());
	}

	protected addOperatorBlock(term: ContentSearchBlock): SearchBlock {
		const block = new SearchBlock({
			term: term,
			isPresentation: true
		});
		this.blocks.push(block);

		return block;
	}

	protected addVocabBlock(term: ContentSearchBlock): SearchBlock {
		const block = new SearchBlock({
			vocabColorPalette: this.props.state.vocabColorPalette[term.descriptor?.vocabularyId],
			term: term,
			isPresentation: true
		});
		this.blocks.push(block);

		return block;
	}
}
